import React from 'react';
import CategorieArea from '../CategorieArea';
import Footer from '../Footer';
import Header from '../Header';

function Categoriepage() {
  return <div>
      <Header/>
      <CategorieArea/>
      <Footer/>
  </div>;
}

export default Categoriepage;
